import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-slate-100">
      <div className="h-px gradient-em" />

      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div className="space-y-3">
            <div className="flex items-center gap-2.5">
              <div className="h-7 w-7 rounded-lg bg-gradient-to-br from-em to-teal flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                NT
              </div>
              <p className="font-bold text-slate-800">Nova Terra Consulting</p>
            </div>
            <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
              Bridging technology investment and business outcomes.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-2.5 text-sm">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-em-dark transition-colors">LinkedIn</a>
            <a href="#contact" className="text-slate-400 hover:text-em-dark transition-colors">Contact</a>
            <a href="/ai-assessment" className="text-slate-400 hover:text-em-dark transition-colors">AI Assessment</a>
            <a href="/privacy-policy" className="text-slate-400 hover:text-em-dark transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="text-slate-400 hover:text-em-dark transition-colors">Terms of Service</a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <p className="text-xs text-slate-400">© {year} Nova Terra Consulting. All rights reserved.</p>
          <p className="text-xs text-slate-300">Fractional COO/CIO · Digital Execution</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
